import styled from 'styled-components/macro';
import { border, colors, distances, grid } from '../../../../styles/constants';

interface PaymentConnectionProps {
    disabled: boolean;
}

const PaymentConnection = styled.div<PaymentConnectionProps>`
    margin-top: ${distances.normal};
    opacity: ${(props) => (props.disabled ? 0.5 : 1)};
`;

const Flex = styled.div`
    display: flex;
    align-items: center;
`;

const ConnectionText = styled.div`
    width: 100%;
`;

const ConnectionAside = styled.div`
    min-width: ${grid.spans.span2};
`;

const Details = styled.div`
    padding: ${distances.small};
    background: ${colors.borderLight};

    &.closed {
        display: none;
    }
`;

const ToggleDetails = styled.button`
    color: ${colors.textSecondary};
    font-size: 11px;
    background: none;
    border: none;
    padding: ${distances.tiny} 0;
    text-decoration: underline;
    margin: 0;
    cursor: pointer;
    &:focus {
        outline: none;
    }
`;

interface ConnectionsStatusProps {
    status: 'pending' | 'failed' | 'enabled' | 'declined';
}

const getStatusColor = (status: 'pending' | 'failed' | 'enabled' | 'declined') => {
    if (status === 'pending') {
        return colors.warning;
    }
    if (status === 'enabled') {
        return colors.primary;
    }
    return colors.invalid;
};

const ConnectionsStatus = styled.div<ConnectionsStatusProps>`
    display: flex;
    align-items: center;
    justify-content: center;
    height: ${distances.large};
    max-width: ${grid.spans.span2};
    border-right: ${border.normal} solid ${(props) => getStatusColor(props.status)};
`;

export { ConnectionsStatus, ConnectionAside, ConnectionText, Flex, ToggleDetails, Details, PaymentConnection };
